// Run status of one LinkedIn account (running / paused / standing by / no browser) as a dot or a badge.
// The derivation lives in lib/accountStatus.ts so every surface agrees.

import { Badge, Tooltip, cx } from "@ml/ui";
import { accountRunState, runStateLabel, RUN_STATE_TONE, type AccountRunState, type RunStatusInput } from "../../lib/accountStatus";
import "./ig-workspaces.css";

/** A small coloured dot. Decorative: pair it with text (or pass `label` for a screen-reader name). */
export function RunDot({ state, label, className }: { state: AccountRunState; label?: string; className?: string }) {
  return (
    <span
      className={cx("gfp-ws-dot", `gfp-ws-dot--${state}`, className)}
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}
    />
  );
}

/** "Running" / "Paused until …" (reason on hover) / "Standing by" / "Not running in any browser". */
export function RunStatusBadge({ account, size = "sm" }: { account: RunStatusInput; size?: "sm" | "md" }) {
  const st = accountRunState(account);
  const badge = (
    <Badge tone={RUN_STATE_TONE[st]} dot size={size} tabIndex={st === "paused" && account.engineStatus?.pauseReason ? 0 : undefined}>
      {runStateLabel(account)}
    </Badge>
  );
  const reason = st === "paused" ? account.engineStatus?.pauseReason : null;
  return reason ? <Tooltip content={reason}>{badge}</Tooltip> : badge;
}
